import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useQuery, useQueryClient } from 'react-query';
import CustomModal from '../UI/Modal/Modal';
import UserInformationTable from './user-information-table/user-information-table';
import { useCities, useCreateUser, useFilias } from '../../api/user-list-api/user-list-api';
import s from './styles.module.css';
import { axiosInstances } from '../../api/axios-instances';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const { Option } = Select;

const getUsers = async ({ queryKey }) => {
    const [, { page, size, search, cityId, filialId }] = queryKey;
    const token = Cookies.get('token');
    if (!token) {
        throw new Error('Token is not available in localStorage');
    }
    const response = await axiosInstances.get(`/amantrans/customers/by-filter`, {
        params: {
            page: page,
            size: size,
            search: search,
            cityId: cityId,
            filialId: filialId,
            isActive: true,
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (response.status !== 200) {
        throw new Error(`Error: ${response.status}`);
    }
    return response.data;
};
const UserList = ({ translation, language }) => {
    const [search, setSearch] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);
    const [errors, setErrors] = useState({});
    const { data: citiesData } = useCities();
    const [pageSize, setPageSize] = useState(25);
    const { data: filiasData, refetch: refetchFilias } = useFilias(selectedCity);
    const [inputData, setInputData] = useState({
        phone: '+7',
        password: '',
        filialId: null,
        fullName: '',
        lastName: '',
    });
    const [role, setRole] = useState(null);
    const [page, setPage] = useState(0);
    const queryClient = useQueryClient();
    const createUser = useCreateUser();
    const [userParams, setUserParams] = useState({
        page: page,
        size: pageSize,
        search: '',
        cityId: '',
        filialId: '',
        isActive: true,
    });
    const {
        data: DataInitial,
        error,
        isLoading,
        refetch,
    } = useQuery(['customers', userParams], getUsers, { keepPreviousData: true });
    useEffect(() => {
        if (selectedCity) {
            refetchFilias();
        }
    }, [selectedCity, refetchFilias]);
    const handleSearchChange = (event) => {
        const cleanedInput = event.target.value.trim().replace(/\s+/g, ' ');
        setSearch(cleanedInput);
    };
    useEffect(() => {
        const token = Cookies.get('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                setRole(decodedToken.role);
            } catch (error) {
                console.error('Ошибка декодирования токена', error);
                setRole('');
            }
        } else {
            setRole('');
        }
    }, []);
    const handleSearchClickFind = () => {
        setPage(0);
        setUserParams({
            page: page,
            size: pageSize,
            search: search,
            cityId: '',
            filialId: '',
            isActive: true,
        });
    };
    const handleSearchKey = (event) => {
        if (event.key === 'Enter') {
            handleSearchClickFind();
        }
    };
    const handleChange = (event) => {
        const selectedNumber = parseInt(event.target.value);
        setPage(selectedNumber);
        setUserParams({
            page: page,
            size: pageSize,
            search: search,
            cityId: '',
            filialId: '',
            isActive: true,
        });
    };
    const handlePageChange = (newPage) => {
        setPage(newPage);
        setUserParams({
            page: page,
            size: pageSize,
            search: search,
            cityId: '',
            filialId: '',
            isActive: true,
        });
    };
    const validateInput = () => {
        const newErrors = {};
        const phoneRegex = /^\+7\d{10}$/;

        if (!phoneRegex.test(inputData.phone)) {
            newErrors.phone = 'Некорректный номер телефона';
        }
        if (inputData.password.length <= 4) {
            newErrors.password = 'Пароль должен быть длиннее 4 символов';
        }
        if (!inputData.phone || !inputData.password) {
            newErrors.general = 'Все поля должны быть заполнены и выбран филиал';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChangeCity = (value) => {
        setSelectedCity(value);
        setInputData((prevState) => ({
            ...prevState,
            filialId: null,
        }));
    };

    const handleChangeFilial = (value) => {
        setInputData((prevState) => ({
            ...prevState,
            filialId: value,
        }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setInputData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        if (value.startsWith('+7') && /^\+7\d*$/.test(value) && value.length <= 12) {
            setInputData((prevState) => ({
                ...prevState,
                phone: value,
            }));
        }
    };
    const handlePageSizeChange = (event) => {
        setPageSize(parseInt(event.target.value));
        setUserParams({
            page: page,
            size: parseInt(event.target.value),
            search: '',
            cityId: '',
            filialId: '',
            isActive: true,
        });
    };
    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleAll = () => {
        setSearch('');
        setUserParams({
            page: page,
            size: pageSize,
            search: '',
            cityId: '',
            filialId: '',
            isActive: true,
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSuccessModal(false);
        setErrors({});
    };

    const handleCreateUser = () => {
        if (validateInput()) {
            const phoneWithoutPlus = inputData.phone.startsWith('+')
                ? inputData.phone.slice(1)
                : inputData.phone;
            const body = {
                phone: phoneWithoutPlus,
                password: inputData.password,
                filialId: role === 'RoleLeadAdmin' ? inputData.filialId : 0,
                fullName: inputData.fullName,
                lastName: inputData.lastName,
            };
            createUser.mutate(body, {
                onSuccess: () => {
                    queryClient.invalidateQueries(['customers']);
                    setOpenModal(false);
                    setSuccessModal(true);
                },
                onError: (error) => {
                    console.error('Error creating customer:', error);
                },
            });
        }
    };
    const tableData = DataInitial;
    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>There was an error!</div>;

    const isKgRole = (role) => role === 'RoleAdminKg' || role === 'RoleLeadAdminKg';

    return (
        <div className={s['container']}>
            <CustomModal visible={openModal} onClose={handleCloseModal}>
                <div className={s['modal-div']}>
                    <p className={s['modal-title']}>{translation('createUser')}</p>
                    <div className={s['input-div']}>
                        <p className={s['text-input']}>{translation('dataUser')}</p>
                        <input
                            className={s['input-modal']}
                            name="fullName"
                            value={inputData.fullName}
                            onChange={handleInputChange}
                            placeholder={`${translation('writeName')}`}
                        />
                        <input
                            className={s['input-modal']}
                            name="lastName"
                            value={inputData.lastName}
                            onChange={handleInputChange}
                            placeholder={`${translation('writeSurname')}`}
                        />
                        {role === 'RoleLeadAdmin' ? (
                            <>
                                {' '}
                                <Select
                                    style={{ width: '100%', height: '56px' }}
                                    onChange={handleChangeCity}
                                    placeholder={`${translation('takeCity')}`}
                                >
                                    {citiesData?.map((item) => (
                                        <Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                                <Select
                                    style={{ width: '100%', height: '56px' }}
                                    onChange={handleChangeFilial}
                                    placeholder={`${translation('takeFilial')}`}
                                >
                                    {filiasData?.content?.map((item) => (
                                        <Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                                {errors.filialId && (
                                    <p className={s['error-text']}>{errors.filialId}</p>
                                )}
                            </>
                        ) : null}
                        <input
                            className={s['input-modal']}
                            name="phone"
                            value={inputData.phone}
                            onChange={handlePhoneChange}
                            placeholder={`${translation('telefonNumber')}`}
                        />
                        {errors.phone && <p className={s['error-text']}>{errors.phone}</p>}
                        <input
                            className={s['input-modal']}
                            name="password"
                            value={inputData.password}
                            onChange={handleInputChange}
                            placeholder={`${translation('createPassword')}`}
                        />
                    </div>
                    <div className={s['modal-button']}>
                        <button className={s['button-modal']} onClick={handleCloseModal}>
                            {translation('otmena')}
                        </button>
                        <button className={s['button-modal']} onClick={handleCreateUser}>
                            {translation('continue')}
                        </button>
                    </div>
                </div>
            </CustomModal>
            <CustomModal visible={successModal} onClose={handleCloseModal}>
                <div className={s['done-modal']}>
                    <p className={s['userPlus']}>{translation('userPlus')}</p>
                    <svg
                        width="101"
                        height="101"
                        viewBox="0 0 101 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M50.1357 100.842C43.3057 100.842 36.8678 99.5346 30.822 96.9202C24.8089 94.3058 19.4985 90.6947 14.8906 86.0869C10.2828 81.479 6.67169 76.1686 4.05731 70.1555C1.44293 64.1098 0.135742 57.6719 0.135742 50.8418C0.135742 44.0117 1.44293 37.5902 4.05731 31.5771C6.67169 25.5313 10.2665 20.2045 14.8416 15.5967C19.4495 10.9889 24.7599 7.37774 30.773 4.76337C36.8187 2.14899 43.2567 0.841797 50.0867 0.841797C56.9168 0.841797 63.3547 2.14899 69.4005 4.76337C75.4462 7.37774 80.773 10.9889 85.3808 15.5967C89.9887 20.2045 93.5998 25.5313 96.2142 31.5771C98.8286 37.5902 100.136 44.0117 100.136 50.8418C100.136 57.6719 98.8286 64.1098 96.2142 70.1555C93.5998 76.1686 89.9887 81.479 85.3808 86.0869C80.773 90.6947 75.4462 94.3058 69.4005 96.9202C63.3874 99.5346 56.9658 100.842 50.1357 100.842ZM44.6455 74.7634C45.4952 74.7634 46.2632 74.5673 46.9495 74.1751C47.6357 73.783 48.2403 73.1947 48.7632 72.4104L71.8024 36.0869C72.0965 35.5967 72.3743 35.0738 72.6357 34.5183C72.8972 33.9627 73.0279 33.4072 73.0279 32.8516C73.0279 31.7078 72.6031 30.8091 71.7534 30.1555C70.9037 29.4692 69.956 29.1261 68.9103 29.1261C67.4723 29.1261 66.2959 29.8777 65.3808 31.381L44.4495 65.0085L34.4985 52.1653C33.8776 51.3483 33.273 50.7928 32.6848 50.4987C32.1292 50.2045 31.492 50.0575 30.773 50.0575C29.6619 50.0575 28.7305 50.466 27.9789 51.283C27.2272 52.0673 26.8514 53.015 26.8514 54.1261C26.8514 54.6817 26.9495 55.2372 27.1455 55.7928C27.3743 56.3157 27.6684 56.8222 28.0279 57.3124L40.3318 72.4104C40.9854 73.2601 41.6553 73.8647 42.3416 74.2242C43.0279 74.5836 43.7959 74.7634 44.6455 74.7634Z"
                            fill="white"
                        />
                    </svg>
                    <button className={s['button-done']} onClick={handleCloseModal}>
                        {translation('continue')}
                    </button>
                </div>
            </CustomModal>
            <div className={s['content']}>
                <div>
                    <h1 className={s['title']}>{translation('users')}</h1>
                </div>
                <div className={s['input']}>
                    <input
                        value={search}
                        onChange={handleSearchChange}
                        className={s['input-style']}
                        placeholder={`${translation('findByName')}`}
                        onKeyDown={handleSearchKey}
                    />
                    <button className={s['found-button']} onClick={handleSearchClickFind}>
                        {translation('find')}
                    </button>
                    {!isKgRole(role) && (
                        <button onClick={handleOpenModal} className={s['found-button']}>
                            {translation('createUser')}
                        </button>
                    )}
                    <button onClick={handleAll} className={s['found-button']}>
                        {translation('showAll')}
                    </button>
                </div> 
                <div className={s['order-div']}>
                    <UserInformationTable
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        initialData={tableData}
                        translation={translation}
                        language={language}
                        page={page}
                        setPage={handleChange}
                        refetch={refetch}
                        handlePageSizeChange={handlePageSizeChange}
                        handlePageChange={handlePageChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default UserList;
